var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formName === 'modifyIndustrialPropertyForm')?_c('ModifyIndustrialPropertyForm'):_c('NewIndustrialPropertyForm')
}
var staticRenderFns = []

export { render, staticRenderFns }